import request from '@/utils/request'
import qs from 'qs'

let formHeader = {'Content-Type': 'application/x-www-form-urlencoded',}

let urlPre = '/api-admin/service/'

export function deployJava() {
    return request({
        url: urlPre + 'deployJava',
        method: 'get',
        headers: formHeader
    })
}

export function deployHtml() {
    return request({
        url: urlPre + 'deployHtml',
        method: 'get',
        headers: formHeader
    })
}

export function restartTomcat() {
    return request({
        url: urlPre + 'restartTomcat',
        method: 'get',
        headers: formHeader
    })
}